import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { 
  APPLICATION_MODE_NEW,
  ROUTE_PATH, 
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION 
} from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";
import TopNavigationBar from "../TopNavigationBar";

const MORTGAGE_APPLICATION_PROPERTY = "hasRequiredEducationQualification";
export const HasCompletedMortgageBrokerEducation = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const title = !isPrincipalBroker ? 
    "Has the applicant completed the Nova Scotia Mortgage Broker Education Program?" : 
    "Have you completed the Nova Scotia Mortgage Broker Education Program?";

  const handleNext = (hasCompletedMortgageBrokerEducation) => () => {
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: hasCompletedMortgageBrokerEducation,
      })
    );

    dispatch(saveBusinessLicenceApplicationData(
      applicationType,APPLICATION_MODE_NEW))
      .then(data => {
        const nextPath = hasCompletedMortgageBrokerEducation
            ? ROUTE_PATH.MRA_HAS_CERTIFICATE_NOVASCOTIA
            : ROUTE_PATH.MRA_COMPLETE_BROKER_EDUCATION;
          dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
      })
      .catch(err => {
        //setApplicationSaveError(true)
      })
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationType} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>
            {title}
          </h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleNext(true)}
            text="Yes"
          />
        </div>

        <div className="col-lg-2">
            <Button
              className="ns-btn-yes-no"
              buttonType="regular_primary"
              onClick={handleNext(false)}
              value={false}
              text="No"
            />
          </div>
      </div>
    </div>
  );
};
